export function view(value) {
  return value
    ? value.startsWith('image/')
      ? 'ImageAttachment'
      : 'OtherAttachment'
    : 'No'
}
